import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css';
import { cartStore } from './store/cart.js';
import { inject } from '@vercel/analytics';

// Initialize Vercel Analytics
inject();

// Initialize cart on app start
cartStore.initializeCart();

createApp(App)
  .use(router)
  .mount('#app');